module.exports = "//static.hsappstatic.net/content-assistance-lib/static-1.2278/img/loading_robot.gif"